<template >
  <!-- https://vuetifyjs.com/en/components/sliders/ -->
  <v-slider
    :label="formDetail.title"
    :max="formDetail.max"
    :min="formDetail.min"
    :step="formDetail.step"
    v-model="sliderValue"
    :class="formDetail.class"
    :name="index"
    :rules="[rulesForm.required, rulesForm.min, rulesForm.max]"
  >
    <template v-slot:append>
      <v-text-field
        v-model="sliderValue"
        hide-details
        single-line
        density="compact"
        type="number"
        style="width: 70px"
      ></v-text-field>
    </template>
  </v-slider>
</template>
 
<script setup>
const props = defineProps({
  formDetail: {
    type: Object,
    required: true,
  },
  model: {
    type: Object,
    required: true,
  },
  index: {
    type: String,
    required: false,
  },
});
const { $form} = useNuxtApp()
const rulesForm = $form.getRules(props.formDetail,props.index);

let sliderValue = ref(props.model[props.index] ? props.model[props.index] : 0);
</script>